import { theme } from 'shared/styles/theme';
import { Button } from 'shared/ui/Button';
import { FormCategoryTitle } from 'shared/ui/FormComponents/FormCategoryTitle';
import { YellowButton } from 'shared/ui/Styled';
import { Flex } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

import { SurveyFinalContent } from './SurveyFinalContent';

type Props = {
  isShowFinalContent: boolean;
  onClose: () => void;
  setIsShowForm: (isShowFinalContent: boolean) => void;
};

export const SurveyModalContent = ({ isShowFinalContent, onClose, setIsShowForm }: Props) => {
  if (isShowFinalContent) return <SurveyFinalContent />;

  return (
    <Flex padding='50px 0 50px 20px' flexDirection='column' gap={40}>
      <Flex flexDirection='column'>
        <FormCategoryTitle>Привет!</FormCategoryTitle>
        <FormCategoryTitle>Помоги сделать SDTech лучше</FormCategoryTitle>
      </Flex>
      <Typography fontSize={theme.fontSizes['17']} mt={-20}>
        Короткий опрос на 5 минут поможет сделать наш продукт еще удобнее
      </Typography>
      <Flex gap={20}>
        <Button onClick={onClose}>В другой раз</Button>
        <YellowButton onClick={() => setIsShowForm(true)}>Хочу помочь</YellowButton>
      </Flex>
    </Flex>
  );
};
